export default function FireSvgIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="21" fill="none" viewBox="0 0 17 21">
      <path
        d="M13.774 4.26c-.29.226-.584.5-.875.818a11.078 11.078 0 0 0-1.251 1.653l-.93 1.577-.497-1.762A8.786 8.786 0 0 0 7.963 2.67a9.057 9.057 0 0 0-1.337-1.106c.174 2.073-.124 3.914-.746 5.494-.303.77-.614 1.312-.837 1.613l-.864 1.161-.499-1.358c-.242-.66-.53-1.182-.848-1.584a4.083 4.083 0 0 0-.268-.308 6.98 6.98 0 0 1-.807 3.409 8.329 8.329 0 0 0-.793 2.363l-.01.057c-.927 4.355 1.953 7.668 7.436 7.803 5.313.13 8.208-3.274 7.393-7.828-.041-.23-.081-.432-.12-.616a7.9 7.9 0 0 0-.348-1.199c-.1-.266-.673-1.587-.87-2.072a8.26 8.26 0 0 1-.232-.645c-.373-1.188-.49-2.42-.439-3.595z"
        stroke="#000"
        strokeWidth="1.5"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </svg>
  );
}
